import React from 'react';
import { useTranslation } from 'react-i18next';
import './OrientationInput.scss';
import OverlayOrientationBottomIcon from '../../../images/overlay-orientation-bottom-icon.png';
import OverlayOrientationMiddleIcon from '../../../images/overlay-orientation-middle-icon.png';
import OverlayOrientationTopIcon from '../../../images/overlay-orientation-top-icon.png';
import ToggleButton from '../../ProducerComponents/ProducerControlPanel/Widgets/ToggleButton';
import useProject from '../../../hooks/useProject';
import { OverlayOrientationEnum } from '../../../types/enums/OverlayOrientationEnum';
import Help from '../../Help/Help';

const OrientationInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();

  const onChange = (value: string | number | boolean) => {
    if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
      updateStream({
        overlayOrientation: value,
      });
    } else {
      updateEncoder(project.encoder, {
        overlayOrientation: value,
      });
    }
  };

  return (
    <div className="orientation-input">
      <div className="input-title">
        {t('producer.inputs.orientation.title')}
        <Help
          title="Overlay Orientation"
          text="Allows you to choose the position of each captions style and adjust from that position - bottom, middle or top of the screen."
        />
      </div>
      <ToggleButton
        leftValue={OverlayOrientationEnum.Bottom}
        leftImage={OverlayOrientationBottomIcon}
        leftButtonClassName={`${
          project.encoder.overlayOrientation === OverlayOrientationEnum.Bottom
            ? 'control-panel-button-selected-button'
            : null
        }`}
        hasMiddleButton={true}
        middleValue={OverlayOrientationEnum.Middle}
        middleImage={OverlayOrientationMiddleIcon}
        middleButtonClassName={`${
          project.encoder?.overlayOrientation === OverlayOrientationEnum.Middle
            ? 'control-panel-button-selected-button'
            : null
        }`}
        rightValue={OverlayOrientationEnum.Top}
        rightImage={OverlayOrientationTopIcon}
        rightButtonClassName={`${
          project.encoder.overlayOrientation === OverlayOrientationEnum.Top
            ? 'control-panel-button-selected-button'
            : null
        }`}
        isReadOnly={false}
        footerText={t('producer.inputs.orientation.footer')}
        onSelection={onChange}
        leftAccessibilityName={t('producer.inputs.orientation.accessibility.bottom')}
        middleAccessibilityName={t('producer.inputs.orientation.accessibility.middle')}
        rightAccessibilityName={t('producer.inputs.orientation.accessibility.top')}
      />
    </div>
  );
};

export default React.memo(OrientationInput);
